import { styled } from '@mui/material/styles';
import { Button } from 'shared/mui/Buttons';
import { Select } from 'shared/mui/Select/Select';

export const ButtonStyled = styled(Button)<{ disabled?: boolean }>(({ theme, disabled }) => ({
  height: '36px',
  borderRight: `1px solid ${disabled ? theme.palette.divider : theme.palette.primary.dark}`,
  borderBottomRightRadius: 0,
  borderTopRightRadius: 0,
}));

export const SelectStyled = styled(Select)<{ disabled?: boolean }>(({ theme, disabled }) => ({
  height: '36px',
  width: '48px',
  backgroundColor: disabled ? 'rgba(0, 0, 0, 0.12)' : theme.palette.primary.main,
  borderBottomLeftRadius: 0,
  borderTopLeftRadius: 0,
  color: theme.palette.common.white,
  '& .MuiSelect-select': {
    fontSize: 0,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '& .MuiSvgIcon-root': {
    marginRight: '6px',
    fill: disabled ? theme.palette.text.disabled : theme.palette.common.white,
  },
}));
